import { render, staticRenderFns } from "./releaseSalon.vue?vue&type=template&id=43b5644e&scoped=true&"
import script from "./releaseSalon.vue?vue&type=script&lang=js&"
export * from "./releaseSalon.vue?vue&type=script&lang=js&"
import style0 from "./releaseSalon.vue?vue&type=style&index=0&id=43b5644e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b5644e",
  null
  
)

export default component.exports